import React from "react";
import { FilterButtonProps } from "../types";

const FilterButton: React.FC<FilterButtonProps> = ({
  option,
  isSelected,
  onClick,
}) => {
  return (
    <button
      onClick={() => onClick(option.id)}
      className={`flex flex-col items-center justify-center p-2 rounded-lg transition-colors whitespace-nowrap ${
        isSelected
          ? "bg-grayBack text-white"
          : "text-grayText hover:bg-gray-600"
      } w-20 h-20 sm:w-24 sm:h-24 flex-shrink-0`}
    >
      <div className="w-10 h-10 mb-2 flex items-center justify-center rounded-full">
        {/* Use the white icon when selected, otherwise use the dark icon */}
        {option.lightIcon && option.darkIcon ? (
          <img
            src={option.lightIcon}
            alt={option.name}
            className="w-auto object-cover"
          />
        ) : (
          <span className="text-xs text-gray-500">No Img</span>
        )}
      </div>
      <span className="text-sm text-center leading-tight font-ubuntu">
        {option.name}
      </span>
    </button>
  );
};

export default FilterButton;
